import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { i18n, setLocale } from './i18n';
import { initTheme } from './composables/useTheme';
import { initCompanyBranding } from './composables/useCompanyBranding';
import { vProse } from './directives/prose-assets';
import { vMentions } from './directives/mentions';
import { useAuthStore } from './stores/auth.store';
import './styles/main.css';

// Apply the persisted theme before the first paint so there is no flash.
initTheme();
// The last company's favicon, so the tab is right before the workspace loads.
initCompanyBranding();

const app = createApp(App);
app.use(createPinia());
app.use(i18n);
app.use(router);
// Stored files inside rendered markdown need the session's token; see the
// directive for why the server cannot just emit a plain `src`.
app.directive('prose', vProse);
// Turns the mention links in a rendered body into chips with the person's face.
app.directive('mentions', vMentions);

// Keep the backend locale header in step with the UI language from the start.
void setLocale((i18n.global.locale as unknown as { value: string }).value, { persist: false });

// The SDK raises this when a refresh finally fails.
window.addEventListener('pro-kanban:signed-out', () => {
  useAuthStore().handleExternalSignOut();
  // Remember where the session died so signing back in returns there.
  const from = router.currentRoute.value;
  const redirect = from.meta.public || from.fullPath === '/' ? undefined : from.fullPath;
  void router.push({ name: 'login', query: redirect ? { redirect } : undefined });
});

app.mount('#app');
